module.exports = __webpack_public_path__ + "img/xqxh3.7bfac80b.png";